export const profileConstants = {
  SET_USER_TYPE: 'SET_USER_TYPE',
  SET_LANGUAGE_POPUP: 'SET_LANGUAGE_POPUP',
  SET_EXPERIENCE_POPUP: 'SET_EXPERIENCE_POPUP',
  SET_PROFILE_POPUP: 'SET_PROFILE_POPUP',
  SET_EDUCATION_POPUP: 'SET_EDUCATION_POPUP',
  SET_IMAGE_CROPPER: 'SET_IMAGE_CROPPER',
  SET_USER_ID: 'SET_USER_ID',
  INITIAL_STATE: 'INITIAL_STATE',
  CLEAR_DATA: 'PROFILE/CLEAR_DATA',

  //get my profile
  GET_MY_PROFILE_REQUEST: 'GET_MY_PROFILE_REQUEST',
  GET_MY_PROFILE_SUCCESS: 'GET_MY_PROFILE_SUCCESS',
  GET_MY_PROFILE_FAILURE: 'GET_MY_PROFILE_FAILURE',

  //put my profile
  PUT_MY_PROFILE_REQUEST: 'PUT_MY_PROFILE_REQUEST',
  PUT_MY_PROFILE_SUCCESS: 'PUT_MY_PROFILE_SUCCESS',
  PUT_MY_PROFILE_FAILURE: 'PUT_MY_PROFILE_FAILURE',

  //get user experience
  GET_USER_EXPERIENCE_REQUEST: 'GET_USER_EXPERIENCE_REQUEST',
  GET_USER_EXPERIENCE_SUCCESS: 'GET_USER_EXPERIENCE_SUCCESS',
  GET_USER_EXPERIENCE_FAILURE: 'GET_USER_EXPERIENCE_FAILURE',

  //add user experience
  ADD_USER_EXPERIENCE_REQUEST: 'ADD_USER_EXPERIENCE_REQUEST',
  ADD_USER_EXPERIENCE_SUCCESS: 'ADD_USER_EXPERIENCE_SUCCESS',
  ADD_USER_EXPERIENCE_FAILURE: 'ADD_USER_EXPERIENCE_FAILURE',

  //update user experience
  UPDATE_USER_EXPERIENCE_REQUEST: 'UPDATE_USER_EXPERIENCE_REQUEST',
  UPDATE_USER_EXPERIENCE_SUCCESS: 'UPDATE_USER_EXPERIENCE_SUCCESS',
  UPDATE_USER_EXPERIENCE_FAILURE: 'UPDATE_USER_EXPERIENCE_FAILURE',

  //delete user experience
  DELETE_USER_EXPERIENCE_REQUEST: 'DELETE_USER_EXPERIENCE_REQUEST',
  DELETE_USER_EXPERIENCE_SUCCESS: 'DELETE_USER_EXPERIENCE_SUCCESS',
  DELETE_USER_EXPERIENCE_FAILURE: 'DELETE_USER_EXPERIENCE_FAILURE',

  //put interest
  PUT_INTEREST_REQUEST: 'PUT_INTEREST_REQUEST',
  PUT_INTEREST_SUCCESS: 'PUT_INTEREST_SUCCESS',
  PUT_INTEREST_FAILURE: 'PUT_INTEREST_FAILURE',

  //add interest
  ADD_INTEREST_REQUEST: 'ADD_INTEREST_REQUEST',
  ADD_INTEREST_SUCCESS: 'ADD_INTEREST_SUCCESS',
  ADD_INTEREST_FAILURE: 'ADD_INTEREST_FAILURE',

  //remove interest
  REMOVE_INTEREST_REQUEST: 'REMOVE_INTEREST_REQUEST',
  REMOVE_INTEREST_SUCCESS: 'REMOVE_INTEREST_SUCCESS',
  REMOVE_INTEREST_FAILURE: 'REMOVE_INTEREST_FAILURE',

  //put profile picture
  PUT_PROFILE_PICTURE_REQUEST: 'PUT_PROFILE_PICTURE_REQUEST',
  PUT_PROFILE_PICTURE_SUCCESS: 'PUT_PROFILE_PICTURE_SUCCESS',
  PUT_PROFILE_PICTURE_FAILURE: 'PUT_PROFILE_PICTURE_FAILURE',

  CLEAR_PICTURE_UPDATE_DATA: 'CLEAR_PICTURE_UPDATE_DATA',
  CLEAR_INTEREST_UPDATE: 'CLEAR_INTEREST_UPDATE',

  //put profile picture popup
  PUT_PROFILE_POPUP_REQUEST: 'PUT_PROFILE_POPUP_REQUEST',
  PUT_PROFILE_POPUP_SUCCESS: 'PUT_PROFILE_POPUP_SUCCESS',
  PUT_PROFILE_POPUP_FAILURE: 'PUT_PROFILE_POPUP_FAILURE',

  GET_USER_EDUCATION_REQUEST: 'GET_USER_EDUCATION_REQUEST',
  GET_USER_EDUCATION_SUCCESS: 'GET_USER_EDUCATION_SUCCESS',
  GET_USER_EDUCATION_FAILURE: 'GET_USER_EDUCATION_FAILURE',

  ADD_USER_EDUCATION_REQUEST: 'ADD_USER_EDUCATION_REQUEST',
  ADD_USER_EDUCATION_SUCCESS: 'ADD_USER_EDUCATION_SUCCESS',
  ADD_USER_EDUCATION_FAILURE: 'ADD_USER_EDUCATION_FAILURE',

  UPDATE_USER_EDUCATION_REQUEST: 'UPDATE_USER_EDUCATION_REQUEST',
  UPDATE_USER_EDUCATION_SUCCESS: 'UPDATE_USER_EDUCATION_SUCCESS',
  UPDATE_USER_EDUCATION_FAILURE: 'UPDATE_USER_EDUCATION_FAILURE',

  DELETE_USER_EDUCATION_REQUEST: 'DELETE_USER_EDUCATION_REQUEST',
  DELETE_USER_EDUCATION_SUCCESS: 'DELETE_USER_EDUCATION_SUCCESS',
  DELETE_USER_EDUCATION_FAILURE: 'DELETE_USER_EDUCATION_FAILURE',

  RESET_EXPERIENCE_POPUP_DATA: 'RESET_EXPERIENCE_POPUP_DATA',
  RESET_EDUCATION_POPUP_DATA: 'RESET_EDUCATION_POPUP_DATA',

  UPDATE_EXPERTISE_REQUEST: 'PROFILE/UPDATE_EXPERTISE_REQUEST',
  UPDATE_EXPERTISE_SUCCESS: 'PROFILE/UPDATE_EXPERTISE_SUCCESS',
  UPDATE_EXPERTISE_FAILURE: 'PROFILE/UPDATE_EXPERTISE_FAILURE',

  SAVE_COVER_PICTURE_REQUEST: 'PROFILE/SAVE_COVER_PICTURE_REQUEST',
  SAVE_COVER_PICTURE_SUCCESS: 'PROFILE/SAVE_COVER_PICTURE_SUCCESS',
  SAVE_COVER_PICTURE_FAILURE: 'PROFILE/SAVE_COVER_PICTURE_FAILURE',

  GET_PROMPT_LIST_REQUEST: 'PROFILE/GET_PROMPT_LIST_REQUEST',
  GET_PROMPT_LIST_SUCCESS: 'PROFILE/GET_PROMPT_LIST_SUCCESS',
  GET_PROMPT_LIST_FAILURE: 'PROFILE/GET_PROMPT_LIST_FAILURE',

  LIKE_OR_DISLIKE_PROMPT_REQUEST: 'PROFILE/LIKE_OR_DISLIKE_PROMPT_REQUEST',
  LIKE_OR_DISLIKE_PROMPT_SUCCESS: 'PROFILE/LIKE_OR_DISLIKE_PROMPT_SUCCESS',
  LIKE_OR_DISLIKE_PROMPT_FAILURE: 'PROFILE/LIKE_OR_DISLIKE_PROMPT_FAILURE',

  ADD_PROMPT_REQUEST: 'PROFILE/ADD_PROMPT_REQUEST',
  ADD_PROMPT_SUCCESS: 'PROFILE/ADD_PROMPT_SUCCESS',
  ADD_PROMPT_FAILURE: 'PROFILE/ADD_PROMPT_FAILURE',

  UPDATE_PROMPT_REQUEST: 'PROFILE/UPDATE_PROMPT_REQUEST',
  UPDATE_PROMPT_SUCCESS: 'PROFILE/UPDATE_PROMPT_SUCCESS',
  UPDATE_PROMPT_FAILURE: 'PROFILE/UPDATE_PROMPT_FAILURE',

  DELETE_PROMPT_REQUEST: 'PROFILE/DELETE_PROMPT_REQUEST',
  DELETE_PROMPT_SUCCESS: 'PROFILE/DELETE_PROMPT_SUCCESS',
  DELETE_PROMPT_FAILURE: 'PROFILE/DELETE_PROMPT_FAILURE'
}
